import { render, staticRenderFns } from "./DefaultUpdated.vue?vue&type=template&id=241dbfdc&"
import script from "./DefaultUpdated.vue?vue&type=script&lang=js&"
export * from "./DefaultUpdated.vue?vue&type=script&lang=js&"
import style0 from "./DefaultUpdated.vue?vue&type=style&index=0&id=241dbfdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports